import React from "react";
import ReactDOM from "react-dom";
import ModalWrapper from "./Android/ModalWrapper";
import "./styles.css";

const GoBackPageForWeb = ({ setScreen, onClose }) => {
  return (
    <div className="go-back-container-for-web">
      <ModalWrapper className="go-back-modal-container-for-web">
        <div className="timer-popup-for-web">
          <div className="go-back-for-web">
            <img src={`../../${process.env.PUBLIC_URL}/images/WarningCircle.svg`} alt="warningcircles" />
            <p className="goBackheading-for-web">Go Back?</p>
            <p className="goBackSubLine-for-web">
              In case your transaction is successfully processed, you will not
              see a successful message. But you will be able to see order
              processed in your merchant app.
            </p>
          </div>
          <div
            tabIndex={-1}
            onClick={() => setScreen("FAILED_PAYMENT")}
            role="button"
            className="go-back-button-for-web"
          >
            Yes, Go Back
          </div>
          <div
            tabIndex={-1}
            onClick={() => onClose()}
            role="button"
            className="go-back-button-for-web"
          >
            No
          </div>
        </div>
      </ModalWrapper>
    </div>
  );
};

export default GoBackPageForWeb;
